import React, { useState } from 'react';
import Parse from 'parse';
import $ from "jquery";
import { commonLogoutFunction } from './common';

const allOptions = [
  "Alabama",
  "Alaska",
  "American Samoa",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "District of Columbia",
  "Federated States of Micronesia",
  "Florida",
  "Georgia",
  "Guam",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Marshall Islands",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Northern Mariana Islands",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Palau",
  "Pennsylvania",
  "Puerto Rico",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virgin Island",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming"
];

class Editprofile extends React.Component {
    constructor(props) {
        super(props);

        let getUsername=localStorage.getItem('username');
        let getUseremail=localStorage.getItem('useremail');
        let currentUser = Parse.User.current();   

        
        if(!currentUser)
        {
            window.location.href = "/";
        }
        let fetchusername= currentUser.get('displayUsername');//currentUser.get('username');

        let name =currentUser.get('displayName'); //currentUser.get("name");
        let bio = currentUser.get("bio");
        let website = currentUser.get("website");
        let creator_name = currentUser.get("creator_name");
        let creator_phonenumber = currentUser.get("creator_phonenumber");
        let city = currentUser.get("city");
        let address1 = currentUser.get("address1");
        let address2 = currentUser.get("address2");
        let states = currentUser.get("state");
        let zipcode = currentUser.get("zipcode");
        let paypal_email = currentUser.get("paypal_email");
        let isCreator = currentUser.get("isCreator");
        /*
        let instagram = currentUser.get("instagram");
        let tiktok = currentUser.get("tiktok");
        let youtube = currentUser.get("youtube");*/
        let profile_picture = currentUser.get("profilePictureMedium");
        if(profile_picture)
        {
            profile_picture=profile_picture._url;
            $("#profilePicturePreview").attr("style", "display: block");
        }else
        {
            profile_picture='';
            $("#profilePicturePreview").attr("style", "display: none");
        }

        this.state = {
            username: getUsername,
            email:getUseremail,
            name:name,
            bio:bio,
            city:city,
            website:website,            
           /* city:city,
            instagram:instagram,
            tiktok:tiktok,
            youtube:youtube,*/
            profile_picture:profile_picture,
            currentUser:currentUser,
            nametext: name,
            namecharCount: (name || '').length,
            namemaxChars: 100,
            usernametext:fetchusername ,
            usernamecharCount: (fetchusername || '').length,
            usernamemaxChars: 100,
            biotext: bio,
            biocharCount: (bio || '').length,
            biomaxChars: 150,
            linktext: website,
            linkcharCount:(website || '').length,
            linkmaxChars: 100,
            profile_message:null,
            profile_message_show:false,
            creator_name_msg:null,
            creator_phone_number_msg:null,
            creator_state_msg:null,
            creator_isCreator:isCreator,
            phonevalue: creator_phonenumber,
            creator_profile_message:null,
            creator_name:creator_name,
            address1:address1,
            address2:address2,
            states:states,
            zipcode:zipcode,
            paypal_email:paypal_email,
            username_exist_message:null,
        };
  
        this.handleProfileSubmit = this.handleProfileSubmit.bind(this);
        this.handleProfilePic = this.handleProfilePic.bind(this);
        this.handleProfileSet = this.handleProfileSet.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleNameTextChange = this.handleNameTextChange.bind(this);
        this.handleUserNameTextChange = this.handleUserNameTextChange.bind(this);
        this.handleBioTextChange = this.handleBioTextChange.bind(this);
        this.handleLinkTextChange = this.handleLinkTextChange.bind(this); 
        this.handleProfileCreatorSubmit = this.handleProfileCreatorSubmit.bind(this);
        this.onPhoneChange = this.onPhoneChange.bind(this);
        this.handleCreatorNameTextChange = this.handleCreatorNameTextChange.bind(this); 
        this.handleCreatorPhoneTextChange = this.handleCreatorPhoneTextChange.bind(this); 
        this.handleCreatorAddress1TextChange = this.handleCreatorAddress1TextChange.bind(this);       
        this.handleCreatorAddress2TextChange = this.handleCreatorAddress2TextChange.bind(this); 
        this.handleCreatorCityTextChange = this.handleCreatorCityTextChange.bind(this);
        this.handleCreatorStateTextChange = this.handleCreatorStateTextChange.bind(this);
        this.handleCreatorZipcodeTextChange = this.handleCreatorZipcodeTextChange.bind(this);
        this.handleCreatorPaypalTextChange = this.handleCreatorPaypalTextChange.bind(this);
        this.handleCreatorIsCreatorTextChange = this.handleCreatorPaypalTextChange.bind(this);
    }

    handleCreatorNameTextChange = (event) => {
      const newText = event.target.value;
      this.setState({
        creator_name: newText
      });
  };
  handleCreatorPhoneTextChange = (event) => {
      const newText = event.target.value;
      this.setState({
        phonevalue: newText
      });
  };
   handleCreatorAddress1TextChange = (event) => {
      const newText = event.target.value;
      this.setState({
        address1: newText
      });
  };
  handleCreatorIsCreatorTextChange = (event) => {
      const newText = event.target.value;

      this.setState({
        //isCreator: newText
      });
  };
  handleCreatorPaypalTextChange = (event) => {
      const newText = event.target.value;
      this.setState({
        paypal_email: newText
      });
  };
  handleCreatorZipcodeTextChange = (event) => {
      const newText = event.target.value;
      this.setState({
        zipcode: newText
      });
  };
   handleCreatorAddress2TextChange = (event) => {
      const newText = event.target.value;
      this.setState({
        address2: newText
      });
  };
   handleCreatorCityTextChange = (event) => {
      const newText = event.target.value;
      this.setState({
        city: newText
      });
  };
  handleCreatorStateTextChange = (event) => {
      const newText = event.target.value;
      this.setState({
        states: newText
      });
  };
  
    onPhoneChange = function(e){
        const re = /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i;
        if (e.target.value === '' || re.test(e.target.value)) {
           this.setState({phonevalue: e.target.value})
        }
    }
    handleLogout = function(e){
        commonLogoutFunction();
    }
    handleProfileSet = function(e){
         let currentUser = Parse.User.current(); 
         let profile_picture = currentUser.get("profilePictureMedium");
         if(profile_picture)
         {
            $("#profilePicturePreview").attr("style", "display: block");
         }else
         {
            $("#profilePicturePreview").attr("style", "display: none");
         }
    }
 handleProfilePic = (e) => {
    const file = e.target.files[0];
const currentUser = Parse.User.current();
    if (currentUser && file) {
        const reader = new FileReader();
        const profilePicturePreview = document.getElementById('profilePicturePreview'); 
        reader.readAsDataURL(file);
        reader.onloadend = async () => {
            const base64 = reader.result.split(',')[1]; // Extract base64 data
            const profilePictureFile = new Parse.File("profilePicture.jpg", { base64 });

            // Save the file to Parse
            currentUser.set('profilePictureMedium', profilePictureFile);
            currentUser.set('profilePictureSmall', profilePictureFile);
           var self = this;   
            try {
                await currentUser.save();
                
                // Show preview
                profilePicturePreview.style = "display: block";
                profilePicturePreview.src = profilePictureFile.url(); 
           
              self.setState({profile_message_show:true}); 
              self.setState({profile_message:'User profile picture updated'}); 
              setTimeout(() => {
                  self.setState({profile_message_show:false});  
                  self.setState({profile_message:null}); 
                  self.setState({username_exist_message:null}); 
              }, 3000);
                this.handleProfileSet(); 
            } catch (error) {
                console.error("File upload failed:", error);
            }
        };
    }
};
    handleProfilePic1 = function(e){
      /*  const profilePicturePreview = document.getElementById('profilePicturePreview');        
        const currentUser = Parse.User.current();
        var filedata=e.target.files[0];   
        if (currentUser && filedata) {   
        var profilePictureFile = new Parse.File("profilePicture.jpg", filedata);
        currentUser.set('profilePictureMedium', profilePictureFile);
        currentUser.set('profilePictureSmall', profilePictureFile);
        var self = this;   
            currentUser.save().then((updatedUser) => {
                profilePicturePreview.style = "display: block";
                profilePicturePreview.src = profilePictureFile.url(); 
           
              self.setState({profile_message_show:true}); 
              self.setState({profile_message:'User profile picture updated'}); 
              setTimeout(() => {
                  self.setState({profile_message_show:false});  
                  self.setState({profile_message:null}); 
                  self.setState({username_exist_message:null}); 
              }, 3000);
                this.handleProfileSet();   
            }).catch((error) => {
            });
        } */

    }


    handleProfileCreatorSubmit(event) {
     event.preventDefault();
     var self = this;   
     var forms = document.forms.new_profile_creator_form;
     var creator_name=forms.creator_name.value;
     var creator_phone_number=forms.creator_phone_number.value;
     var address1=forms.creator_address1.value;
     var address2=forms.creator_address2.value;
     var city=forms.creator_city.value;
     var creator_state=forms.creator_state.value;
     var zipcode=forms.creator_zipcode.value;
     var paypal_email=forms.creator_paypal_email.value;
     let isCreator=0;
     let creator_isCreator=this.state.creator_isCreator;
     console.log(creator_isCreator+'ddd');
     if(creator_name==='')
     {
        self.setState({creator_name_msg:"Please enter name!"}); 
     }
     if(creator_phone_number==='')
     {
        self.setState({creator_phone_number_msg:"Please enter phone number!"}); 
     }
     if(creator_state==='')
     {
        self.setState({creator_state_msg:"Please select state!"}); 
     }
     if(creator_isCreator===true || creator_isCreator===1)
     {
        isCreator=1;
     }
     console.log(isCreator+'creator_isCreator');
     if(creator_state!=='' && creator_name!=='' && creator_phone_number!=='')
     {
       const currentUser = Parse.User.current();
       if(currentUser) {
         currentUser.set("isCreator", isCreator);
         currentUser.set('creator_name', creator_name);
         currentUser.set('creator_phonenumber', creator_phone_number);
         currentUser.set('address1', address1);
         currentUser.set('address2', address2);
         currentUser.set('city', city);
         currentUser.set('state', creator_state);
         currentUser.set('zipcode', zipcode);
         currentUser.set('paypal_email', paypal_email);
         var self = this;  
         currentUser.save().then((updatedUser) => {
             self.setState({creator_profile_message:'Creator profile updated successfully'}); 
              setTimeout(() => {
              self.setState({creator_profile_message:null});               
            }, 3000);
          }).catch((error) => {
         });
      }
    }

      setTimeout(() => {
                  self.setState({creator_name_msg:null});  
                  self.setState({creator_phone_number_msg:null}); 
                  self.setState({creator_state_msg:null});
              }, 3000);





   }
   
    handleProfileSubmit(event) {
     event.preventDefault();
     var forms = document.forms.new_profile_form;
     var name=forms.name.value;
     //var email=forms.email.value;
     var username=forms.username.value;
     var bio=forms.bio.value;
     var website=forms.website.value;
     /*var city=forms.city.value;
     var instagram=forms.instagram.value;
     var tiktok=forms.tiktok.value;
     var youtube=forms.youtube.value;*/

     var fullname=name.split(/(?<=^\S+)\s/);//name.split(" ");
     var firstName='';
     var lastName='';
     if(fullname[0]==undefined)
     {
         firstName='';         
     }else
     {
         firstName=fullname[0];
     }
     if(fullname[1]==undefined)
     {
        lastName='';        
     }else
     {
         lastName=fullname[1];
     }
     //const profilePicture = new Parse.File("profilePicture.jpg", newProfilePictureFile);


     const currentUser = Parse.User.current();
     if (currentUser) {
        var self = this;  
          var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.include("username");
               query.equalTo("displayUsername", username);
               query.notEqualTo('objectId', currentUser.id);
               query.first().then(function(result){
                if(result){
                     console.log(result);
                     self.setState({username_exist_message:'Username already exist!'});
                     setTimeout(() => {
                          self.setState({username_exist_message:null}); 
                        }, 3000);
                }else{
                    //Update profile data
                    //currentUser.set('name', name);
                    currentUser.set('name', name);
                    currentUser.set('bio', bio);
                    currentUser.set('website', website);
                    //currentUser.set('city', city);
                    //currentUser.set('username', username);
                    //currentUser.set('email', email);
                    //currentUser.set('instagram', instagram);
                    //currentUser.set('tiktok', tiktok);
                    //currentUser.set('youtube', youtube);
                    currentUser.set("displayName", name);
                    currentUser.set("displayUsername", username);
                    currentUser.set("isCreator", 0);
                    currentUser.set("firstName", firstName);
                    currentUser.set("lastName", lastName);
                    currentUser.set("veganSince", '');
                    //currentUser.set("isAdmin",  '0');
                    currentUser.set("recipeRate", '$0');
                    currentUser.set("videoRate", '');
                    //currentUser.set("isBusiness", 0);
                    
                    //Save changes
                    currentUser.save().then((updatedUser) => {
                         self.setState({profile_message_show:true}); 
                         self.setState({profile_message:'User profile updated successfully'}); 
                          setTimeout(() => {
                          self.setState({profile_message_show:false});  
                          self.setState({profile_message:null}); 
                          self.setState({username_exist_message:null}); 
                        }, 3000);
                    }).catch((error) => {
                    });
                }
            })




        
    } else {
        //console.error('No user is currently logged in.');
    }

    }

  
 handleUserNameTextChange = (event) => {
    let fetchusername;
     const currentUser = Parse.User.current();
    /*if(event.target.value=='')
    {
       fetchusername= currentUser.get('displayUsername');//currentUser.get('username');
    }else
    {
        fetchusername=event.target.value;
    }*/
    // $(this).val($(this).val().toLowerCase());
    fetchusername=event.target.value.toLowerCase().replace(/\s/g,'');
    const newText =fetchusername; //event.target.value;
    if (newText.length <= this.state.usernamemaxChars) {
    this.setState({
      usernametext: newText,
      usernamecharCount: newText.length
    });
   }
  };
handleNameTextChange = (event) => {
    const newText = event.target.value;
    if (newText.length <= this.state.namemaxChars) {
    this.setState({
      nametext: newText,
      namecharCount: newText.length
    });
   }
  };
  handleBioTextChange = (event) => {
    const newText = event.target.value;
    if (newText.length <= this.state.biomaxChars) {
    this.setState({
      biotext: newText
    });
   }
  };
handleBioTextChange = (event) => {
    const newText = event.target.value;
    if (newText.length <= this.state.biomaxChars) {
    this.setState({
      biotext: newText,
      biocharCount: newText.length
    });
   }
  };
  handleLinkTextChange = (event) => {
    const newText = event.target.value;
    if (newText.length <= this.state.linkmaxChars) {
    this.setState({
      linktext: newText,
      linkcharCount: newText.length
    });
   }
  };

    render() {
        var fetchUsername = this.state.username;
        ///var fetchEmail = this.state.email;
        var fetchName = this.state.name;
        var fetchBio = this.state.bio;
        var fetchWebsite = this.state.website;
       /* var fetchCity = this.state.city;
        var fetchInstagram = this.state.instagram;
        var fetchTiktok = this.state.tiktok;
        var fetchYoutube = this.state.youtube;*/
        var fetchProfile_picture =this.state.profile_picture;
        
        const currentUser = Parse.User.current();
        fetchUsername=currentUser.get('displayUsername');//currentUser.get("username");
        let profile_pictures = currentUser.get("profilePictureMedium");
        
        if(profile_pictures)
        {  
            profile_pictures=profile_pictures._url; 
        }else
        {
        }
        var result = (
          <section className='post_list profile-edit'>
            <div className='container'>
              <div className='inner'>
                <nav className='sidebar'>
                  <ul className='border-0 nav flex-column nav-tabs' id="myTab" role="tablist">
                    <li className='back-page'><a href="javascript: window.history.back()"><img src="/images/back_top.svg" alt="Back to Top" /></a></li>
                    <li className='sidebar-item'><a id="editprfl-tab" className='active' data-toggle="tab" href="#editprfl" type="button" role="tab" aria-controls="editprfl" aria-selected="true">Edit Profile</a></li>
                    <li className='sidebar-item'><a id="cretaccunt-tab" data-toggle="tab" href="#cretaccunt" type="button" role="tab" aria-controls="cretaccunt" aria-selected="false">Creator Account</a></li>
                  </ul>
                </nav>
                <main className='listing profilefrm'>
                  <div className='tab-content' id='myTabContent'>
                    <div className="tab-pane edit-prf-tab fade show active " id="editprfl" role="tabpanel" aria-labelledby="editprfl-tab">
                      <div className="form_grp form-part">
                        <p className='profile_message_alert'>{this.state.profile_message}</p>
                        <p className='profile_message_alert_red'>{this.state.username_exist_message}</p>
                        <form className="form-signup form_mn" id="new_profile_form" onSubmit={this.handleProfileSubmit}>
                          <div className="frm_wrapper">
                            <div className="title-part">
                              <h2 className="heading">{'Edit Profile'}</h2>
                              <p>Information you add here will be visible on your public profile.</p>
                            </div>
                            <div className="content-part">
                              <div className='top-part'>
                                <div className='thumbnail'>
                                  {fetchProfile_picture!=""?
                                    <img height="150" width="150" id="profilePicturePreview" src={fetchProfile_picture} alt="Profile Picture" />
                                    :
                                    <img height="150" width="150" id="profilePicturePreview" src="/images/default_userpic0.png" alt="Profile Picture" />
                                  }                              
                                </div>
                                <div className='frm_userinformation'>
                                  <span className='usrtxt'>{this.state.usernametext}</span>
                                  <span className='nametxt'>{this.state.nametext}</span>                                   
                                </div>
                                <div className='file-upld'>
                                  <label htmlFor="profilePic">Change photo </label>  
                                  <input id='profilePic' accept=".jpg, .jpeg, .png" type="file" onChange={this.handleProfilePic} />
                                </div>
                              </div>
                              <div className='frm-part'>
                                <div className="frm_grp">
                                  <label>Name</label>
                                  <div className='frm_wrap'>
                                    <input type="text"
                                      placeholder=""
                                      size="large"
                                      name="name"
                                      value={this.state.nametext}
                                      onChange={this.handleNameTextChange}
                                      defaultValue={fetchName}
                                      className="form-control"                                  
                                    />
                                  {/* <span className="char_count char_count_name">{this.state.namecharCount}/{this.state.namemaxChars} </span>*/}
                                  </div>
                                </div>
                                <div className="frm_grp">
                                  <label>Username</label>
                                  <div className='frm_wrap'>
                                  {/*readOnly="true"*/}
                                    <input type="text"
                                      placeholder=""
                                      size="large"                                  
                                      name="username"

                                      defaultValue={fetchUsername}
                                      className="form-control"
                                      value={this.state.usernametext}
                                      onChange={this.handleUserNameTextChange}
                                      required                              
                                    />
                                  {/* <span className="char_count char_count_username">{this.state.usernamecharCount}/{this.state.usernamemaxChars} </span>*/}
                                  </div>
                                </div>   
                                <div className="frm_grp bio_frm_grp">
                                  <label>Bio</label>
                                  <div className='frm_wrap'>
                                    <textarea  placeholder=""
                                      size="large"
                                      defaultValue={fetchBio}     
                                      value={this.state.biotext}
                                      onChange={this.handleBioTextChange}       
                                      name="bio"
                                      rows="3"
                                      className="form-control"
                                    />
                                  {/* <span className="char_count char_count_bio">{this.state.biocharCount}/{this.state.biomaxChars} </span>*/}
                                  </div>       
                                </div>
                                <div className="frm_grp">
                                  <label>Website</label>
                                  <div className='frm_wrap'>
                                    <input type="url"
                                      placeholder=""
                                      size="large"
                                      value={this.state.linktext}
                                      onChange={this.handleLinkTextChange}      
                                      name="website"
                                      defaultValue={fetchWebsite}
                                      className="form-control"           
                                    />
                                    {/*<span className="char_count char_count_link">{this.state.linkcharCount}/{this.state.linkmaxChars} </span>*/} 
                                  </div>      
                                </div>
                                <div className="action cta_btn d-flex flex-row flex-wrap align-items-center justify-content-end">
                                  <div className="fourth-btn btn-wrp">
                                      <a href="/" title='Cancel'>Cancel</a>
                                  </div>
                                  <div className="third-btn btn-wrp">
                                    <button type="primary" className="form_button" color={'#208AEC'} size="large">Save </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="tab-pane crat-acnt-tab fade" id="cretaccunt" role="tabpanel" aria-labelledby="cretaccunt-tab">
                      <div className="form_grp form-part create-account">
                        <p className='profile_message_alert'>{this.state.creator_profile_message}</p>
                        <form className="form-signup form_mn" id="new_profile_creator_form" onSubmit={this.handleProfileCreatorSubmit}>
                          <div className="frm_wrapper">
                            <div className="title-part">
                              <h2 className="heading">{'Creator Account'}</h2>
                              <p>Creators on Joel's Kitchen have the opportunity to collaborate with brands on paid campaigns and generate income. To begin, please provide the information below.</p>
                              <div className='switch-crt-acnt'>
                                <label className="switch">
                                  <input type="checkbox"  value="1" id="creator_isCreator" name="creator_isCreator"  checked={this.state.creator_isCreator}   onClick={()=>this.setState({creator_isCreator:!this.state.creator_isCreator})} />
                                  <span className="slider round"></span>
                                </label>
                                <span className='switch-lbl'>Switch to a Creator Account</span>
                              </div>
                            </div>
                            <div className="content-part">
                              <div className='frm-part'>
                                <h3 className='frm-tlt'>Contact Information</h3>
                                <div className="frm_grp">
                                  <label>Name</label>
                                  <div className='frm_wrap'>
                                    <input type="text"
                                      name="creator_name" id="creator_name"
                                      className="form-control"    
                                      defaultValue={this.state.creator_name}     
                                      value={this.state.creator_name} 
                                      onChange={this.handleCreatorNameTextChange}                              
                                    />
                                      <p className='profile_message_alert'>{this.state.creator_name_msg}</p>
                                  </div>
                                </div>
                                <div className="frm_grp">
                                  <label>Phone number</label>
                                  <div className='frm_wrap'>
                                    <input 
                                      name="creator_phone_number" id="creator_phone_number"
                                       onChange={this.onPhoneChange} defaultValue={this.state.phonevalue}      value={this.state.phonevalue} 
                                      className="form-control"                                  
                                    /> <p className='profile_message_alert'>{this.state.creator_phone_number_msg}</p>
                                  </div>
                                </div>
                              </div>
                              <div className='frm-part'>
                                <h3 className='frm-tlt'>Address</h3>
                                <p>If you want to collect brand samples, please include your mailing address.</p>
                                <div className="frm_grp">
                                  <label>Street address 1</label> 
                                  <div className='frm_wrap'>
                                    <input type="text"
                                      onChange={this.handleCreatorAddress1TextChange} defaultValue={this.state.address1}      value={this.state.address1} 
                                      name="creator_address1" id="creator_address1"
                                      className="form-control"                                  
                                    />
                                  </div>
                                </div>
                                <div className="frm_grp">
                                  <label>Street address 2</label>
                                  <div className='frm_wrap'>
                                    <input type="text"
                                      onChange={this.handleCreatorAddress2TextChange} defaultValue={this.state.address2}      value={this.state.address2} 
                                        name="creator_address2" id="creator_address2"
                                      className="form-control"                                  
                                    />
                                  </div>
                                </div>
                                <div className="frm_grp">
                                  <label>City</label>
                                  <div className='frm_wrap'>
                                    <input type="text"
                                      name="creator_city" id="creator_city"
                                       onChange={this.handleCreatorCityTextChange} defaultValue={this.state.city}      value={this.state.city}
                                      className="form-control"                                  
                                    />
                                  </div>
                                </div>
                                <div className="frm_grp frm_grp_stat">
                                  <label>State</label>
                                  <div className='frm_wrap'>
                                  {/*value={this.state.challengeStatus} 
                                        onChange={this.handleStatusChange}*/}
                                    <select  onChange={this.handleCreatorStateTextChange}  defaultValue={this.state.states}       className='creator_state' id="creator_state"> 
                                      <option value=""></option>                                       
                                       {allOptions.map(option => ( 
                                          <option key={option} value={option}  data-id={this.state.state}> 
                                            {option} 
                                          </option> 
                                        ))} 
                                      </select> 
                                       <p className='profile_message_alert'>{this.state.creator_state_msg}</p>
                                  </div>
                                </div>
                                <div className="frm_grp frm_grp_zip">
                                  <label>Zip Code</label>
                                  <div className='frm_wrap'>
                                    <input type="text"
                                     onChange={this.handleCreatorZipcodeTextChange} 
                                      defaultValue={this.state.zipcode}      value={this.state.zipcode}
                                      name="creator_zipcode" id="creator_zipcode"
                                      className="form-control"                                  
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='frm-part'>
                                <h3 className='frm-tlt'>Payments</h3>
                                <p>In order to collect your payments, connect your PayPal account. <img src="/images/info-icon.svg" alt="Info Icon"/> </p>
                                <div className='frm-part_inner'>
                                  <div className='lft-img'>
                                    <img src="/images/paypal_icon.png" alt="Paypal"/>
                                  </div>
                                  <div className='rght-inpt'>
                                    <div className="frm_grp">
                                      <label>Email address</label>
                                      <div className='frm_wrap'>
                                        <input type="email"
                                         onChange={this.handleCreatorPaypalTextChange} 
                                      defaultValue={this.state.paypal_email}      value={this.state.paypal_email}
                                          name="creator_paypal_email" id="creator_paypal_email"
                                          className="form-control"                                  
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className='frm-part justify-content-end'>
                                <div className="action cta_btn d-flex flex-row flex-wrap align-items-center justify-content-end">
                                  <div className="fourth-btn btn-wrp">
                                    <a href="javascript: window.history.back()" title='Cancel'>Cancel</a>
                                  </div>
                                  <div className="third-btn btn-wrp">
                                    <button type="primary" className="form_button"  size="large">Save </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </section>

        );
       
        return result;
      

    }


}

export default Editprofile;


// WEBPACK FOOTER //
// ./src/Editprofile.jsx